import React from 'react';
import {Card, Table} from 'antd';
import TickerChip from "../../components/TickerChip";
import {stringMixin} from "../../utils/strings";
import {DoubleLine} from "../../components/Labels";
import PnL from "../../components/PnL";

const TickerTable = ({tickers})=>{

    const columns = [
        {
            key: 'name',
            title: "Security",
            render: (_, record)=><TickerChip ticker={record} />
        },
        {
            key: 'exchange',
            title: "Exchange",
            dataIndex: ['exchange']
        },
        {
            key: 'sector/industry',
            title: "Sector/Industry",
            render: (_, record)=><DoubleLine title={record.tags.sector} text={record.tags.industry} />
        },
        {
            key: ['metrics', 'dy'],
            title: "Dividend Yield",
            dataIndex: ['metrics', 'dy'],
            render: (dy)=>stringMixin.pct(dy)
        },
        {
            key: ['stats', 'benchmarks', 'spy', 'corr_1_yr'],
            title: "Correlation 1Yr",
            dataIndex: ['stats', 'benchmarks', 'spy', 'corr_1_yr'],
            render: (corr)=>stringMixin.pct(corr)
        },
        {
            key: ['stats', 'benchmarks', 'spy', 'upside'],
            title: "Upside",
            dataIndex: ['stats', 'benchmarks', 'spy', 'upside'],
            render: (v)=>stringMixin.pct(v, {mult:1})
        },
        {
            key: ['stats', 'benchmarks', 'spy', 'downside'],
            title: "Downside",
            dataIndex: ['stats', 'benchmarks', 'spy', 'downside'],
            render: (v)=>stringMixin.pct(v, {mult:1})
        },
    ];



    return (
        <Table
            columns={columns}
            dataSource={tickers}
            pagination={{
                pageSize: 50
            }}
            scroll={{y: '70vh', x: 'max-content'}}
        />
    )
}


export default TickerTable;